import { useQuery } from "@tanstack/react-query";

import { useAuth } from "contexts/AuthContext";
import { UserProfile } from "utils/userProfiles";

export const useGetUserProfileQuery = (userId: string) => {
  
  const { authApi } = useAuth();

  const result = useQuery({
    queryKey: ["userProfile", userId],
    queryFn: async () => {
      const { data } = await authApi.get<UserProfile>(`/user-profiles/user/${userId}`);
      return data;
    },
  });

  return result;
};
